const CATEGORIES = ["General", "Care Coordination", "Programs", "PBM", "Fees", "Risk"];

const categoryIndex = (category) => {
    const index = CATEGORIES.indexOf(category);
    return index === -1 ? CATEGORIES.length : index;
};

const catalogDataColumns = (fields) =>
    [...(fields ?? [])]
        .filter((field) => field.identityBinding == null && field.status !== "INACTIVE")
        .sort(
            (left, right) =>
                categoryIndex(left.category) - categoryIndex(right.category)
                || (left.sortOrder ?? 0) - (right.sortOrder ?? 0)
                || String(left.displayName).localeCompare(String(right.displayName))
                || String(left.fieldKey).localeCompare(String(right.fieldKey)),
        )
        .map((field) => ({
            key: field.fieldKey,
            label: field.displayName,
            category: field.category,
            frozen: false,
            width: 160,
            value: (row) => row.fields?.[field.fieldKey] ?? null,
        }));

const categoryGroupsFor = (columns) =>
    CATEGORIES.map((category) => ({
        category,
        columns: columns.filter((column) => !column.frozen && column.category === category),
    })).filter((group) => group.columns.length > 0);

const gridLayout = (displayFrozen, categoryGroups) => {
    const tableColumns = [...displayFrozen, ...categoryGroups.flatMap((group) => group.columns)];
    const frozenOffsets = new Map();
    displayFrozen.reduce((offset, column) => {
        frozenOffsets.set(column.key, offset);
        return offset + column.width;
    }, 0);
    return {
        displayFrozen,
        categoryGroups,
        tableColumns,
        lastFrozenKey: displayFrozen[displayFrozen.length - 1]?.key,
        frozenWidth: displayFrozen.reduce((total, column) => total + column.width, 0),
        tableWidth: tableColumns.reduce((total, column) => total + column.width, 0),
        groupStartKeys: new Set(categoryGroups.map((group) => group.columns[0].key)),
        frozenOffsets,
    };
};

const columnCellProps = (column, layout, extraClassName) => {
    const className = [
        column.frozen && "is-frozen",
        column.key === layout.lastFrozenKey && "is-frozen-edge",
        layout.groupStartKeys.has(column.key) && "is-group-start",
        extraClassName,
    ]
        .filter(Boolean)
        .join(" ");
    return {
        className: className || undefined,
        style: column.frozen ? { left: layout.frozenOffsets.get(column.key) } : undefined,
    };
};

export { catalogDataColumns, categoryGroupsFor, columnCellProps, gridLayout };
